import * as React from 'react'
import { ErrorGroupObservation, errorGroupTitle, ObservationState } from '../domain/Error'
import { extractServerDisplayNameFromHostname } from '../domain/Observation'
import Link from '../helper/link'
import { ObservationIcon } from './ObservationIcon'
import LargeNumber from '../helper/large-number'
import MomentDate from '../momentDate'
import moment from 'moment/moment'

interface Props {
    observation: ErrorGroupObservation
    currentPage: number
    active: boolean
}

export class ObservationListItem extends React.PureComponent<Props> {
    public render() {
        const observation = this.props.observation

        const routeParams = {
            error: observation.id,
            page: this.props.currentPage,
            offset: 0,
        }

        const title = errorGroupTitle(observation)

        let subHeader = (
            <>
                Servers:{' '}
                {Object.keys(observation.observation.affectedOrigins)
                    .map(extractServerDisplayNameFromHostname)
                    .join(', ')}
            </>
        )

        if (observation.fingerprint.startsWith('bottleneck-')) {
            if (observation.observation.affectedOrigins.All) {
                const origin = observation.observation.affectedOrigins.All
                subHeader = (
                    <span>
                        Count: <LargeNumber class="" value={parseInt(origin.value, 10)} /> &middot; Last Recorded:{' '}
                        <strong>
                            <MomentDate date={moment.unix(origin.timestamp).utc()} />
                        </strong>
                    </span>
                )
            }
        }

        return (
            <div className={'error-item' + (this.props.active ? ' active' : '')}>
                <Link params={routeParams}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0, flexGrow: 0 }}>
                        <ObservationIcon observation={observation} />
                        <div className="error-item-type text-ellipsis">
                            <div className="tw-font-size-16 text-ellipsis" title={title}>
                                {observation.observation.state === ObservationState.OK
                                    ? observation.observation.labelOff
                                    : observation.observation.label}
                            </div>
                            {observation.observation.state > 0 ? <div className="error-item-source text-ellipsis">{subHeader}</div> : null}
                        </div>
                    </div>
                </Link>
            </div>
        )
    }
}
